import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/index';
@Component({
  selector: 'app-add-user-success-modal',
  templateUrl: './add-user-success-modal.component.html',
  styleUrls: ['./add-user-success-modal.component.scss']
})
export class AddUserSuccessModalComponent implements OnInit {
  siteName = '';
  userName = '';
  constructor(
    public dialogRef: MatDialogRef<AddUserSuccessModalComponent>,
    @Inject(MAT_DIALOG_DATA) public user: any,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.userName =
      !this.commonService.isNullOrUndefined(this.user.ntId) &&
      this.user.ntId !== ''
        ? this.user.ntId
        : this.user.username;
    if (!this.commonService.isNullOrUndefined(this.user.sites)) {
      for (let i = 0; i < this.user.sites.length; i++) {
        this.siteName += this.user.sites[i].siteName;
        if (i < this.user.sites.length - 1) {
          this.siteName += ' , ';
        }
      }
    }
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: true });
  }
}
